import { render, staticRenderFns } from "./MenuAvoirFour.vue?vue&type=template&id=e365dbfe&scoped=true&"
import script from "./MenuAvoirFour.vue?vue&type=script&lang=js&"
export * from "./MenuAvoirFour.vue?vue&type=script&lang=js&"
import style0 from "./MenuAvoirFour.vue?vue&type=style&index=0&id=e365dbfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e365dbfe",
  null
  
)

export default component.exports